<template>
	<div class="row">
		<div class="col-sm-8">
			<aBox title="Perfil">
				<div slot="tools">
					<aButton
						icon="save"
						text="Salvar"
						type="primary"
						size="sm"
						:disabled="opened_profile.desc == null"
						@click="save_permission"
					/>
				</div>
				<div slot="body">
					<div class="well well-sm">
						<div class="row">
							<div class="col-sm-8">
								<b>Filtrar</b>
								<input
									type="text"
									v-model="search"
									class="form-control"
								/>
							</div>
							<div class="col-sm-4">
								<b>Status</b>
								<select v-model="status" class="form-control">
									<option value="1">Marcadas</option>
									<option value="0">Desmarcadas</option>
								</select>
							</div>
						</div>
					</div>
					<br />

					<div class="row">
						<div class="col-sm-8">
							<b>Titulo do perfil</b>
							<input
								type="text"
								class="form-control"
								v-model="opened_profile.desc"
								:disabled="opened_profile.desc == null"
							/>
						</div>
						<div class="col-sm-4">
							<b>Página inicial</b>
							<select
								:disabled="opened_profile.desc == null"
								v-model="opened_profile.start_page"
								class="form-control"
							>
								<option
									v-for="(page, index) in listPages"
									:key="index"
									:value="page.value"
								>
									{{ page.text }}
								</option>
							</select>
						</div>
					</div>
					<br />
					<b>Permissões</b>
					<table class="table table-hover">
						<tbody>
							<tr
								v-for="(permission, index) in renderList"
								:key="index"
							>
								<td class="checkbox no-margin">
									<label>
										<input
											type="checkbox"
											:checked="
												is_check(permission.hash[0])
											"
											@change="
												toggle_permission(
													permission.hash[0]
												)
											"
											:disabled="
												opened_profile.licenses == null
											"
										/>
										<b>{{ permission.title }}</b>
										<span>{{ permission.hash[0] }}</span>
									</label>
								</td>
							</tr>
							<tr v-if="renderList.length == 0">
								<td>Nenhuma permissão atende o filtro!</td>
							</tr>
						</tbody>
					</table>
				</div>
			</aBox>
		</div>
		<div class="col-sm-4">
			<aBox title="Lista de Perfis" no-padding>
				<div slot="tools">
					<aButton
						text="Novo"
						size="sm"
						type="success"
						icon="plus"
						@click="new_profile"
					/>
				</div>
				<div slot="body">
					<table class="table table-bordered table-striped no-margin">
						<tbody>
							<tr v-for="(perfil, index) in perfis" :key="index">
								<td>
									{{ perfil.desc }}
									<span class="pull-right">
										<aButton
											size="xs"
											type="primary"
											icon="edit"
											@click="open_perfil(perfil)"
										/>
										<aButton
											size="xs"
											type="danger"
											icon="trash"
											@click="delete_perfil(perfil.cod)"
										/>
									</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</aBox>
		</div>
	</div>
</template>
<script>
	import aBox from 'box';
	import aButton from 'btn';
	import aModal from 'modal';
	import wbs from 'js/http';
	import clone from 'js/clone';
	import toastr from 'toastr';

	import mapManu from '../../cnt-app/components/mapMenu.js';

	export default {
		name: 'AppLincense',
		components: { aBox, aButton, aModal },
		data() {
			return {
				perfis: [],
				permissions: [],
				search: '',
				status: '1',

				opened_profile: {
					desc: null,
					licenses: null,
					start_page: '/dashboard',
				},
			};
		},
		computed: {
			renderList() {
				return this.permissions.filter((item) => {
					const search =
						item.title
							.toLowerCase()
							.indexOf(this.search.toLowerCase()) != -1;
					const status =
						(this.status == '1' && this.is_check(item.hash)) ||
						(this.status == '0' && !this.is_check(item.hash));
					if (search && status) return item;
				});
			},
			listPages() {
				return mapManu.reduce((acc, item) => {
					if (item.childs == undefined) {
						if (item.link != undefined)
							acc.push({ value: item.link, text: item.text });
					} else {
						item.childs.forEach((iChild) => {
							if (iChild.link != undefined)
								acc.push({
									value: iChild.link,
									text: `${item.text} -> ${iChild.text}`,
								});
						});
					}
					return acc;
				}, []);
			},
		},
		methods: {
			new_profile() {
				this.opened_profile = {
					desc: '',
					licenses: [],
				};
			},
			open_perfil(perfil) {
				this.opened_profile = clone(perfil);
			},
			is_check(license) {
				if (this.opened_profile.licenses == null) return false;
				if (Array.isArray(license)) license = license[0];
				let check = this.opened_profile.licenses.findIndex(
					(item) => item == license
				);
				return check != -1 ? true : false;
			},
			toggle_permission(license) {
				if (this.opened_profile.licenses == null) return false;

				let check = this.opened_profile.licenses.findIndex(
					(item) => item == license
				);
				if (check == -1) this.opened_profile.licenses.push(license);
				else this.opened_profile.licenses.splice(check, 1);
			},
			save_permission() {
				if (this.opened_profile.desc == '') {
					toastr.warning('Preencha o titulo!');
				} else {
					wbs.send(
						'private-save-perfil',
						this.opened_profile,
						(resp) => {
							//console.log(resp)
							if (resp.status == 'success') {
								toastr.success('Perfil salvo com sucesso!');
								let id_open = this.perfis.findIndex(
									(item) => item.cod == resp.data
								);
								if (id_open == -1) {
									this.opened_profile.cod = resp.data;
									this.perfis.push(
										clone(this.opened_profile)
									);
									this.opened_profile = {
										desc: null,
										licenses: null,
									};
								} else {
									this.$set(
										this.perfis,
										id_open,
										clone(this.opened_profile)
									);
									this.opened_profile = {
										desc: null,
										licenses: null,
									};
								}
							} else {
								toastr.error(resp.msgs[0]);
								console.log(resp);
							}
						}
					);
				}
			},

			delete_perfil(cod) {
				wbs.send('private-delete-perfil', cod, (resp) => {
					if (resp.status == 'success' && resp.data == true) {
						toastr.success('Perfil excluido com sucesso!');
						let esc_id = this.perfis.findIndex(
							(item) => item.cod == cod
						);
						this.perfis.splice(esc_id, 1);
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
					}
				});
			},
		},
		mounted() {
			// console.log(this.listPages)
			this.$emit('setHeader', [
				'Perfis',
				'Gerenciamento de perfis de acesso!',
			]);
			wbs.send('private-read-perfis', (resp) => {
				// console.log(resp)
				if (resp.status == 'success') {
					this.perfis = resp.data.perfis;
					this.permissions = resp.data.permissions;
				} else {
					toastr.error(resp.msgs[0]);
					console.log(resp);
				}
			});
		},
	};
</script>
<style scoped>
	.checkbox input {
		width: 31px;
		height: 27px;
		display: block;
		margin: 4px 0px 0 -36px;
	}
	.checkbox label {
		display: block;
		margin: 0 0px -7px 0px;
		padding-left: 37px;
	}
	.checkbox b {
		display: block;
		margin-top: -8px;
	}
	.checkbox span {
		display: block;
		margin: -6px 0 0 0;
		color: #cecece;
	}
</style>



// WEBPACK FOOTER //
// src/components/settings/perfis/index.vue